// Misc
import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'

// Atoms
import Toolbar from '@material-ui/core/Toolbar'
import Logo from 'components/Layout/Logo'

// Styles
const styles = {
  root: {
    position: 'absolute',
    top: 0,
    maxWidth: 1200,
    zIndex: 2,
    width: '100%',
    left: '50%',
    transform: 'translateX(-50%)',
  }
}

export default
@withStyles(styles)
class LayoutLogo extends Component {
  static propTypes = {
    classes: PropTypes.object.isRequired,
  }

  render() {
    const { classes } = this.props
    return (
      <Toolbar className={classes.root}>
        <Logo largeOnDesktop />
      </Toolbar>
    )
  }
}
